export default function CallToAction() {
  return (
    <section className="py-24 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
          Ready to bring clarity to your operations?
        </h2>
        
        <p className="text-lg text-gray-300 mb-10 max-w-2xl mx-auto">
          Schedule a strategy call to explore how Annalogix can design intelligent workflows tailored to your organization.
        </p>

        <div className="flex items-center justify-center">
          <button className="px-8 py-3.5 bg-blue-500 text-white text-sm font-semibold rounded-lg hover:bg-blue-600 transition-all cursor-pointer whitespace-nowrap shadow-lg">
            Book a Strategy Call
          </button>
        </div>
      </div>
    </section>
  );
}
